export default "__VITE_ASSET__3$F4GyyA__"